import { observable, action, runInAction } from 'mobx'
import Api from '@api/hotel/CalendarModeApi'
import store from '../store'

class Store {
  //查询条件
  @observable entity_id = ''
  @observable year = new Date().getFullYear().toString()
  @observable months = '1'
  @action
  setBanquetHall(value) {
    this.entity_id = value
  }
  @action
  setYear(value) {
    this.year = value
  }
  @action
  setMonths(value) {
    this.months = value
  }
  @action
  search() {
    this.getList()
  }
  @action
  reset() {
    this.entity_id = ''
    this.year = new Date().getFullYear().toString()
    this.months = '1'
  }
  @observable list = {}
  @observable loading = false
  @action
  async getList() {
    let params = this.getSearchParams()
    let {
      data: { list = {} }
    } = await Api.getAllCalendarMode(params)
    runInAction('list', () => {
      this.list = list
    })
  }
  getSearchParams() {
    const { entity_id, year, months } = this
    const { hotelHalls } = store
    let date_min
    let date_max
    let allEntity_id = hotelHalls.map(item => item.id)
    switch (months) {
      case '1':
        date_min = year + '-01-01'
        date_max = year + '-04-01'
        break
      case '2':
        date_min = year + '-04-01'
        date_max = year + '-07-01'
        break
      case '3':
        date_min = year + '-07-01'
        date_max = year + '-10-01'
        break
      case '4':
        date_min = year + '-10-01'
        date_max = Number(year) + 1 + '-01-01'
        break
      default:
        break
    }
    if (entity_id) {
      return {
        entity_id: Number(entity_id),
        date_max,
        date_min
      }
    } else {
      return {
        entity_id: allEntity_id.join(','),
        date_max,
        date_min
      }
    }
  }
}

export default new Store()
